import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";

@Component({
    selector: 'app-payment-schedule-selector-dialog',
    template: require('./paymentScheduleSelector.html')
})
export class PaymentScheduleSelectorDialog {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(MatDialogRef<PaymentScheduleSelectorDialog>) public dialogRef: MatDialogRef<PaymentScheduleSelectorDialog>,
        @Inject(Router) private router: Router) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

    navigateToScheduleEdit(paymentScheduleId: number) {
        this.router.navigateByUrl('/scheduleEdit/' + paymentScheduleId, { state: { scheduleId: paymentScheduleId } });
    }
}
